import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
const render = (imgs) => {
  if (imgs) window.__ofImages = imgs;
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
};

let cachedImages = null;
try { cachedImages = JSON.parse(localStorage.getItem("of_images_cache")); } catch { cachedImages = null; }
if (cachedImages || !window.__ofImgP) render(cachedImages);
else Promise.race([window.__ofImgP, new Promise((r) => setTimeout(() => r(null), 1500))]).then(render);
